import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type OnboardingRoutingDecision =
	| { action: 'show-landing' }
	| { action: 'show-agreement' }
	| { action: 'redirect-to-organization'; organizationId: string }
	| { action: 'show-create-organization' }

type OnboardingRoutingArgs = {
	licensePlan?: string
	lastOrganizationId?: string
}

export const bffApi = createApi({
	reducerPath: 'bffApi',
	baseQuery: fetchBaseQuery({ baseUrl: '/bff', credentials: 'include' }),
	keepUnusedDataFor: 0,
	endpoints: (builder) => ({
		onboardingRouting: builder.query<OnboardingRoutingDecision, OnboardingRoutingArgs>({
			query: ({ licensePlan, lastOrganizationId }) => ({
				url: '/onboarding/routing',
				params: { licensePlan, lastOrganizationId },
			}),
		}),
	}),
})

export const { useOnboardingRoutingQuery } = bffApi
